import React, { useCallback, useState, useEffect } from "react";
import { Loading } from "../../../../../components/Loading/index.jsx";
import styles from "./styles.module.scss";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService.js";
import Swal from "sweetalert2";
import { PiCopySimple } from "react-icons/pi";

const Intelipost = () => {
  const api = new BrComerceApiService();

  const [loading, setLoading] = useState(false);

  const [apiKey, setApiKey] = useState("");
  const [intelipostApiKey, setIntelipostApiKey] = useState("");

  const [copiedUrl, setCopiedUrl] = useState(false);

  const [sedexCode, setSedexCode] = useState("");
  const [pacCode, setPacCode] = useState("");
  const [pacminiCode, setPacminiCode] = useState("");
  const [ownDeliveryCode, setOwnDeliveryCode] = useState("");

  const [activeInsurance, setActiveInsurance] = useState(false);

  const [activeCreateOrder, setActiveCreateOrder] = useState(true);

  const baseUrl = `${process.env.REACT_APP_API_HOST}/intelipost/webhook/order/create`;

  const handleApiKey = (e) => {
    setApiKey(e?.target?.value)
  };

  const handleIntelipostApiKey = (e) => {
    setIntelipostApiKey(e?.target?.value)
  };

  const handleCopyWebhookUrl = () => {
    navigator.clipboard.writeText(baseUrl);
    setCopiedUrl(true);
  };

  const handleSubmit = useCallback(
    async (key, value) => {
      api.makeHttpRequest({
        url: "/intelipost/config",
        method: "POST",
        data: {
          key: key,
          value: value
        }
      });
    },
    [api]
  );

  const sendData = async () => {
    try {
      await Promise.all([
        handleSubmit("API_KEY", apiKey),
        handleSubmit("INTELIPOST_API_KEY", intelipostApiKey),
        handleSubmit("SEDEX_OPTION_CODE", sedexCode),
        handleSubmit("PAC_OPTION_CODE", pacCode),
        handleSubmit("PACMINI_OPTION_CODE", pacminiCode),
        handleSubmit("OWN_DELIVERY_OPTION_CODE", ownDeliveryCode),
        activeInsurance
          ? handleSubmit("IS_ACTIVE_INSURANCE", "true")
          : handleSubmit("IS_ACTIVE_INSURANCE", "false"),
        activeCreateOrder
          ? handleSubmit("IS_INACTIVE_ORDER_CREATE", "false")
          : handleSubmit("IS_INACTIVE_ORDER_CREATE", "true"),
      ]);

      Swal.fire({
        title: "Sucesso!",
        text: "Configurações cadastradas com sucesso.",
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Não foi possível fazer a deleção do envio."
      });
    }
  };


  const loadingConfig = useCallback(async () => {
    await Promise.all([
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/API_KEY`
        })
        .then(res => {
          if (res) {
            setApiKey(res);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/INTELIPOST_API_KEY`
        })
        .then(res => {
          if (res) {
            setIntelipostApiKey(res);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/SEDEX_OPTION_CODE`
        })
        .then(sedexCode => {
          if (sedexCode) {
            setSedexCode(sedexCode);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/PAC_OPTION_CODE`
        })
        .then(pacCode => {
          if (pacCode) {
            setPacCode(pacCode);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/PACMINI_OPTION_CODE`
        })
        .then(pacminiCode => {
          if (pacminiCode) {
            setPacminiCode(pacminiCode);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/OWN_DELIVERY_OPTION_CODE`
        })
        .then(ownDeliveryCode => {
          if (ownDeliveryCode) {
            setOwnDeliveryCode(ownDeliveryCode);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/IS_ACTIVE_INSURANCE`
        })
        .then(active => {
          if (active === "true") {
            setActiveInsurance(true);
          }
        }),
      api
        .makeHttpRequest({
          method: "GET",
          url: `/intelipost/config/IS_INACTIVE_ORDER_CREATE`
        })
        .then(inactive => {
          if (inactive === "true") {
            setActiveCreateOrder(false);
          }
        })
    ]);
  }, [api]);

  useEffect(() => {
    if (!copiedUrl) return;

    const timeout = setTimeout(() => {
      setCopiedUrl(false);
    }, 2500);

    return () => clearTimeout(timeout);
  }, [copiedUrl]);

  useEffect(() => {
    setLoading(true);

    loadingConfig()
      .then(() => {
        console.log("Configurações ok");
      })
      .catch(() => {
        Swal.fire({
          title: "Erro!",
          text: "Não foi possível carregar as informações da loja Intelipost.",
          icon: "error"
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSedexCode = useCallback(e => {
    setSedexCode(e?.target?.value)
  }, []);

  const handlePacCode = useCallback(e => {
    setPacCode(e?.target?.value)

  }, []);

  const handlePacminiCode = useCallback(e => {
    setPacminiCode(e?.target?.value)

  }, []);

  const handleOwnDeliveryCode = useCallback(e => {
    setOwnDeliveryCode(e?.target?.value)
  }, []);


  useEffect(() => {
    window.setPageTitle("Integrações | Intelipost");
  }, []);

  return (
    <>
      <Loading loading={loading} />
      <div className={styles.container}>
        <div className={styles.content}>
          {
            (!apiKey || !intelipostApiKey) && !loading &&
            <div className={styles.warningBanner}>
              <p>
                Entre em contato com a <b>Intelipost</b> para obter as informações necessárias para a integração.
              </p>
            </div>
          }
          <div className={styles.contentHeader}>
            <h2>Configurações</h2>
          </div>
          <div className={styles.contentBody}>
            <section>
              <div>
                <h4>
                  URL para envio dos pedidos:
                </h4>
                <div className={styles.contentSection}>
                  <div
                    className={styles.inputCustomUrl}
                    onClick={handleCopyWebhookUrl}
                  >
                    <input
                      type="text"
                      placeholder=""
                      value={baseUrl}
                      disabled
                    />
                    <PiCopySimple />
                    <div>
                      <p className={styles.textClipped}>
                        {copiedUrl
                          ? "Copiado com sucesso!"
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h4>Chave API para Logística:</h4>
                <div className={styles.contentSection}>
                  <div className={styles.inputApiKey}>
                    <input
                      type="text"
                      name="apiKey"
                      value={apiKey}
                      onChange={handleApiKey}
                      placeholder="Insira a chave da API para logística"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h4>Chave API Intelipost:</h4>
                <div className={styles.contentSection}>
                  <div className={styles.inputApiKey}>
                    <input
                      type="text"
                      name="intelipostApiKey"
                      value={intelipostApiKey}
                      onChange={handleIntelipostApiKey}
                      placeholder="Insira a chave da API Intelipost"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.contentSectionServices}>
                <h4>Códigos de Serviço:</h4>
                <div className={styles.contentSection}>
                  <p>Expresso: </p>
                  <div className={styles.input}>
                    <input
                      type="text"
                      name="sedexCode"
                      value={sedexCode}
                      onChange={handleSedexCode}
                      placeholder="Digite o código do Expresso"
                    />
                  </div>
                </div>
                <div className={styles.contentSection}>
                  <p>Econômico: </p>
                  <div className={styles.input}>
                    <input
                      type="text"
                      name="pacCode"
                      value={pacCode}
                      onChange={handlePacCode}
                      placeholder="Digite o código do Econômico"
                    />
                  </div>
                </div>
                <div className={styles.contentSection}>
                  <p>Super Econômico: </p>
                  <div className={styles.input}>
                    <input
                      type="text"
                      name="pacminiCode"
                      value={pacminiCode}
                      onChange={handlePacminiCode}
                      placeholder="Digite o código do Super Econômico"
                    />
                  </div>
                </div>
                <div className={styles.contentSection}>
                  <p>Super Expresso: </p>
                  <div className={styles.input}>
                    <input
                      type="text"
                      name="ownDeliveryCode"
                      value={ownDeliveryCode}
                      onChange={handleOwnDeliveryCode}
                      placeholder="Digite o código do Super Expresso"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h4>Criação de pedido</h4>
                <p style={{ marginTop: "16px" }}>
                  Abaixo é possível ativar ou desatitvar a criação de pedidos.
                  <br />
                  Serviços como cotação funcionarão normalmente
                </p>
                <div>
                  <div className={styles.contentSection}>
                    <div className={styles.switchOption}>
                      <label className={styles.switch}>
                        <input
                          type="checkbox"
                          onChange={event =>
                            setActiveCreateOrder(event.target.checked)
                          }
                          checked={activeCreateOrder}
                        />
                        <span
                          className={`${styles.slider} ${styles.round}`}
                        ></span>
                      </label>
                      {activeCreateOrder ? "Ativado" : "Desativado"}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h4>Configuração de Seguro</h4>
                <p style={{ marginTop: "16px" }}>
                  Abaixo é possível ativar ou desatitvar a cotação de frete com
                  Seguro. Essa opção é válida para todos os fretes <br /> que
                  são cotados.
                </p>
                <div className={styles.contentSection}>
                  <div className={styles.switchOption}>
                    <label className={styles.switch}>
                      <input
                        type="checkbox"
                        onChange={event =>
                          setActiveInsurance(event.target.checked)
                        }
                        checked={activeInsurance}
                        disabled={!apiKey}
                      />
                      <span
                        className={`${styles.slider} ${styles.round}`}
                      ></span>
                    </label>
                    {activeInsurance ? "Ativado" : "Desativado"}
                  </div>
                </div>
              </div>
              <div className={styles.buttonWrapper}>
                <button
                  type="submit"
                  onClick={sendData}
                  className={styles.button}
                  disabled={(!apiKey || !intelipostApiKey) || !(sedexCode || pacCode || pacminiCode || ownDeliveryCode)}
                >
                  Salvar
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export { Intelipost };
